import * as Sentry from "@sentry/react";

export const setSentryUser = (userData) => {
  try {
    Sentry.setUser({
      id: userData.id?.toString(),
      email: userData.email,
      username: userData.name || userData.alias,
    });
  } catch (e) {
    console.warn("Failed to set Sentry user:", e);
  }
};

const initSentry = () => {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  const environment = import.meta.env.VITE_APP_ENV || "production";
  if (!dsn) {
    console.warn("Sentry DSN not configured. Error tracking will be disabled.");
    return;
  }
  Sentry.init({
    dsn: dsn,
    environment: environment,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: environment === "production" ? 0.1 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event, hint) {
      if (event.exception) {
        const error = hint.originalException || hint.syntheticException;
        if (error && typeof error === "object") {
          if (error.message?.includes("ResizeObserver loop limit exceeded")) {
            return null;
          }
          if (error.message?.includes("Non-Error promise rejection captured")) {
            return null;
          }
          if (error.message?.includes("ChunkLoadError")) {
            return null;
          }
        }
      }
      return event;
    },
  });
  const userData = localStorage.getItem("user");
  if (userData) {
    try {
      const user = JSON.parse(userData);
      if (user?.data) {
        setSentryUser(user.data);
      }
    } catch (e) {
      console.warn("Failed to parse user data for Sentry:", e);
    }
  }
};

export const clearSentryUser = () => {
  try {
    Sentry.setUser(null);
  } catch (e) {
    console.warn("Failed to clear Sentry user:", e);
  }
};

export default initSentry;
